// @ts-nocheck
import type { Requests } from '../../../../base/realtime-session';
import type { BillingGet } from '../../../../types/server/modules/billing/get';

export type * from '../../../../types/server/modules/billing/get';

export const createGet = ( requests: Requests ): BillingGet => ({
  get_my_subscription_amount_due: ( headers ) => {
      return requests.get( `/billing/my-subscription/amount-due`, undefined, headers );
    },
  get_my_subscription_invoices: ( params,headers ) => {
      return requests.get( `/billing/my-subscription/subscription-invoices`, params, headers );
    },
  get_my_subscription_card_on_file: ( headers ) => {
      return requests.get( `/billing/my-subscription/card-on-file`, undefined, headers );
    },
  get_my_subscription_pay_attempt: ( params,headers ) => {
      return requests.get( `/billing/my-subscription/pay-attempt/:intentId`, params, headers );
    },
  get_account_termination_preview: ( params,headers ) => {
      return requests.get( `/billing/account-termination-preview/:clientAccountId`, params, headers );
    }
});
